<template>
  <v-dialog scrollable v-model="config.status.active" max-width="600">
    <v-card>
      <v-card-title class="blue darken-2 white--text">
        <span class="headline">{{ printTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form" v-model="form.valid" lazy-validation>
            <v-row dense>
              <v-col cols="12" class="px-3">
                <v-text-field required ref="name"
                  v-model="form.name"
                  :label="printFormLabel"
                  :rules="rules.name"
                  :suffix="form.ext"
                  @keypress.enter.prevent="submit"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text
          color="secondary"
          @click="close">閉じる</v-btn>
        <v-btn depressed color="secondary white--text"
          :disabled="!isValid"
          :loading="isLoading"
          @click="submit">保存する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'renameModal',
  props: [
  ],
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false,
          searching: false
        }
      },
      meta: {
      },
      form: {
        name: '',
        ext: ''
      },
      store: {
        item: null
      },
      rules: {
        name: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    init: function (item) {
      if (item) {
        let names = item.name ? item.name.split('.') : ['']
        let ext = names.length === 1 ? '' : ('.' + names.pop())
        this.$set(this, 'form', {
          valid: true,
          name: names.join('.'),
          ext: ext
        })
      } else {
        this.$set(this, 'form', {
          valid: true,
          name: '',
          ext: ''
        })
      }
    },
    open: function (item) {
      if (item) {
        this.$set(this.store, 'item', item)
        this.init(item)
        this.$set(this.config.status, 'active', true)
        this.$nextTick(() => {
          this.$refs.name.focus()
        })
      }
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$set(this.config.status, 'loading', true)
        const { id, type, name } = this.store.item
        if (id && type && name) {
          const typeJP = (type === 'file') ? 'ファイル' : (type === 'folder' ? 'フォルダ' : '')
          const url = `${this.$url.api}box/rename/${type}/${id}`
          this.$firebase.auth().currentUser.getIdToken(true).then(token => {
            this.axios.post(url, {
              name: this.form.name ? (this.form.name + this.form.ext) : this.store.item.name
            }, {
              headers: {
                'firebase-token': token
              }
            }).then(res => {
              console.log(res)
              this.$set(this.config.status, 'loading', false)
              if (res.data && res.data.success) {
                this.$emit('emit', {
                  action: 'renamed',
                  data: res.data.data
                })
                this.close()
              } else if (
                res.data &&
                res.data.data &&
                res.data.data.response &&
                res.data.data.response.body &&
                res.data.data.response.body.code
              ) {
                let code = res.data.data.response.body.code
                let err = this.$error.box[type].rename[code] ? this.$error.box[type].rename[code] : ''
                if (err) {
                  this.$store.dispatch('notifier/addAlert', {
                    title: typeJP + '名の変更',
                    message: err
                  })
                }
              }
            })
          })
        }
      }
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    isLoading () {
      return this.config.status.loading
    },
    isSearching () {
      return this.config.status.searching
    },
    printTitle () {
      return (
        this.store.item &&
        this.store.item.type &&
        this.store.item.type === 'file'
      ) ? 'ファイル名の変更' : 'フォルダ名の変更'
    },
    printFormLabel () {
      return (
        this.store.item &&
        this.store.item.type &&
        this.store.item.type === 'file'
      ) ? 'このファイルの新しい名前を入力してください' : 'このフォルダの新しい名前を入力してください'
    }
  }
}
</script>
